import { BaseModel } from '../../_base/crud';
import { RelationshipCategory } from './relationship-category.model';

export class CategoryDescription extends BaseModel {
  id: number;
  category: RelationshipCategory;
  description_type: string;
}
